import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  dailogContainer: {
    overflow: 'visible',

    '& > *': {
      overflowY: 'visible',
    },
    '& > div > button': {
      zIndex: 20,
    },

    '&.isDark': {
      backgroundColor: '#1A1C1E',
    },
    '&.isDark > div > button': {
      backgroundColor: theme.colors.gray2[4],

      '& path': {
        stroke: theme.white,
      },
    },
  },
  dialogBody: {
    position: 'relative',
    width: 500,
    margin: '0 auto',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.fn.smallerThan('sm')]: {
      padding: theme.other.spacing._16,
      width: `calc(100vw - ${theme.other.spacing._16 * 2}px)`,
    },
  },
  dialogGradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 100,
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 1.00) 0%, #FFF 100%)',
    borderTopLeftRadius: theme.other.spacing._24,
    borderTopRightRadius: theme.other.spacing._24,
    zIndex: 2,
  },

  tierBadgeContainer: {
    margin: '0 auto',
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ -150,
    zIndex: 3,
  },

  contentWrapper: {
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ -124,

    [theme.fn.smallerThan('sm')]: {
      marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ -112, // Smaller padding in drawer view
    },

    paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ 100,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    maxHeight: 'calc(100vh - 275px)',
    overflowY: 'auto',
    zIndex: 1,
  },

  statusContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.colors.gray2[3],
  },

  progressBarContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginTop: theme.other.spacing._8,
  },

  faqContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginTop: theme.other.spacing._24,
  },
}));
